import type { Ref } from 'vue';
import { toRefs } from 'vue';

export interface ReadonlyRef<T> extends Ref<T> {
  readonly value: T;
}

export type ToReadonlyRef<T extends Ref<unknown>> = T extends Ref<infer K>
  ? ReadonlyRef<K>
  : never;

export function readonlyRef<T>(value: Ref<T>): ToReadonlyRef<Ref<T>> {
  return value as ToReadonlyRef<Ref<T>>;
}

export type ToReadonlyRefs<T> = {
  [P in keyof T]: T[P] extends Ref<infer K>
    ? ReadonlyRef<K>
    : ToReadonlyRefs<T[P]>;
};

export function refsReadonly<T>(object: T): ToReadonlyRefs<T> {
  return object as unknown as ToReadonlyRefs<T>;
}

export function toRefsReadonly<T extends Record<string, unknown>>(
  object: T
): ToReadonlyRefs<T> {
  return refsReadonly(toRefs(object)) as ToReadonlyRefs<T>;
}
